import { createAction } from 'utils/redux'

export const receiveClassifications = (classifications) =>
  createAction({
    type: 'RECEIVE_CLASSIFICATIONS',
    classifications,
  })
